module.exports = __webpack_public_path__ + "img/gender.416d706b.svg";